import CustomHeader from '../../../baseComponents/gui/customHeader/CustomHeader';
import { getHeader } from '../../../../constants/copyright';
import { useCurrentStore } from '../../../../hooks/useCurrentStore';
import { CSSTransition } from 'react-transition-group';
import { useAppState } from '../../../../redux/reducer/content';
import { HEADER_STATES } from '../../../../constants/components/features/header/states';

export default function Header() {
  const state = useAppState();
  const store = useCurrentStore();
  const headerData = getHeader(store);

  return (
    <CSSTransition
      in={HEADER_STATES.includes(state)}
      timeout={300}
      mountOnEnter
      unmountOnExit
      classNames={'custom-header'}
    >
      <CustomHeader {...headerData} />
    </CSSTransition>
  );
}
